import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { WEEKDAYS_VN, CALENDAR_DOW, MONTHS_VN } from "../XoSoCompound/constants";

dayjs.extend(utc);

export { WEEKDAYS_VN, CALENDAR_DOW, MONTHS_VN };

export const TZ = "Asia/Ho_Chi_Minh";
export const GAME = "MOT_HAI_BA";
export const TITLE = "Kết quả xổ số điện toán 1*2*3";
export const PRODUCT = "1*2*3";
export const DRAW_TIME = "18:05";
export const FIRST_DRAW = "2011-04-01";
export const HISTORY_DAYS = 10;

export function drawDateKey(drawDate) {
  if (!drawDate) return null;
  const raw = String(drawDate);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? dayjs(raw) : dayjs.utc(raw);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
}
